export enum TrainingApprovalRequestStatusEnum {
    DRAFT = 'draft',
    IN_PROGRESS = 'in_progress',
    APPROVED = 'approved',
    REJECTED = 'rejected',
    COMPLETED = 'completed',
    CANCELED = 'canceled',
}
